<template>
  <div :id="attachId" class="attach-container">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :transition="false"
      offset-y
      :attach="`#${attachId}`"
      min-width="300"
      max-width="400"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :label="label"
          v-bind="attrs"
          :value="formattedDate"
          append-icon="mdi-calendar"
          dense
          outlined
          hide-details
          clearable
          readonly
          v-on="on"
          @click:clear="onDateClear"
        />
      </template>

      <v-date-picker
        v-model="selectedDate"
        no-title
        scrollable
        :first-day-of-week="1"
        width="100%"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false
    },
    attachId: {
      type: String,
      default: "dtarray"
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    formattedDate() {
      return this.dateFormat(this.selectedDate);
    }
  },
  methods: {
    dateFormat(date) {
      return date ? moment(date).format("DD.MM.yyyy") : "";
    },
    onDateClear() {
      this.selectedDate = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.attach-container {
  position: relative;
}
</style>
